import React from 'react';

import { Box, Card, CardContent, CircularProgress, Container, Grid, Typography } from '@material-ui/core';

import './offerPaid.css';

function RoadMapComponent({ currentStep }) {
  return (<>
    <Grid
      container
      spacing={2}
      className="offer-roadmap"
    >
      <div className="offer-active-step">
        <span>1</span> Sign Up
      </div>
      <div
        className={currentStep > 1 ? 'offer-active-step' : 'offer-inactive-step'}
      >
        <span>2</span> Select Offer
      </div>
      <div
        className={currentStep > 1 ? 'offer-active-step' : 'offer-inactive-step'}
      >
        <span>2</span> Get Started
      </div>
    </Grid>
  </>);
}

export const RoadMap = RoadMapComponent;